import { render, staticRenderFns } from "./ManageOrganization.vue?vue&type=template&id=47f0dba5&scoped=true&"
import script from "./ManageOrganization.vue?vue&type=script&lang=ts&"
export * from "./ManageOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0dba5",
  null
  
)

export default component.exports